import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { responsiveStoreEnhancer } from 'redux-responsive'

import './index.css';
import App from './App';
import reducers from './reducers';

const store = createStore(reducers, responsiveStoreEnhancer);

ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>
    , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js